import { render, staticRenderFns } from "./ListaUnidad.vue?vue&type=template&id=46c478ee"
import script from "./ListaUnidad.vue?vue&type=script&lang=js"
export * from "./ListaUnidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports